<template>
  <div>
    <h5>Search Phrase</h5>
    <div>
      <el-input
          placeholder="Your search phrase."
          v-model.lazy="filterSearchPhrase"
          @keyup.enter.native="loadResultsOnEnter()"
          size="small">
      </el-input>
    </div>
    <div>
    <div style="font-size: 11px; color: #8e8e8e; margin-left: 10px; margin-right: 10px;">
      <ul style="line-height: 12px;">
        <li>Searches in <u>title</u> and <u>content</u>.</li>
        <li><span style="font-weight: bold; text-decoration: underline">Option 1:</span> Add a <u>single</u> or <u>multiple words</u>. <br>
          e.g. <i style="color: #ff6b00">cat stains</i> means both words must be found in the text in any order. Words in between is ok.</li>
        <li><span style="font-weight: bold; text-decoration: underline">Option 2:</span> To match the <u>phrase exactly</u>, just put it in quotes! e.g. <i style="color: #ff6b00"><b>"</b>cat stains<b>"</b></i></li>
      </ul>
    </div>
    </div>
    <div v-show="false" style="margin-top: 0px">
        <el-checkbox label="Search in Title" @change="setSearchInTitle" border v-model="filterSearchInTitle" size="mini"></el-checkbox>
        <el-checkbox label="Search in Text" @change="setSearchInText" border v-model="filterSearchInText" size="mini"></el-checkbox>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
      }
    },
    methods: {
      setSearchInTitle(value){
        this.$store.dispatch('setMPPSearchInTitle', value);
      },
      setSearchInText(value){
        this.$store.dispatch('setMPPSearchInText', value);
      },
      loadResultsOnEnter(){
        this.$store.dispatch('setMPPFetchingResultsNow', true);
        this.$store.dispatch('globalActionMPPFetchResults').then(response => {
          /*No action on response yet*/
        });
      }
    },
    computed: {
      filterSearchPhrase: {
        get(){
          return this.$store.getters.getMPPSearchPhrase;
        },
        set(searchString){
          this.$store.dispatch('setMPPSearchPhrase', searchString);
        }
      },
      filterSearchInText: {
        get(){
          return this.$store.getters.getMPPSearchInText;
        },
        set(){
          /*Not Used in Element UI - Use change instead*/
        }
      },
      filterSearchInTitle: {
        get(){
          return this.$store.getters.getMPPSearchInTitle;
        },
        set(){
          /*Not Used in Element UI - Use change instead*/
        }
      }
    }
  }

</script>

<style scoped lang="scss">

</style>